import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AccordionContext from '../accordion.context';
import AnimateHeight from 'react-animate-height';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop  {string} [className]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifAccordionContent = (props) => {
  const { children, className = '', ...other } = props;
  const { visible } = useContext(AccordionContext);

  const classes = classNames({
    'motif-accordion-content': true,
    [className]: true
  });

  return (
    <AnimateHeight duration={150} height={visible ? 'auto' : 0}>
      <div className={classes} {...other}>
        {children}
      </div>
    </AnimateHeight>
  );
};

MotifAccordionContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export { MotifAccordionContent };
